module.exports = __webpack_public_path__ + "images/operatorhub-header-logo.svg";